import React from 'react';

const FileDownloadIcon = () => {
	return (
		<svg
			data-testid='file-download-icon'
			fill='none'
			height='36'
			viewBox='0 0 36 36'
			width='36'
		>
			<path
				d='M21.375 4.5V12.375H29.25L21.375 4.5Z'
				fill='#2E2E6B'
				opacity='0.2'
			/>
			<path
				d='M28.125 31.5H7.875C7.57663 31.5 7.29048 31.3815 7.07951 31.1705C6.86853 30.9595 6.75 30.6734 6.75 30.375V5.625C6.75 5.32663 6.86853 5.04048 7.07951 4.82951C7.29048 4.61853 7.57663 4.5 7.875 4.5H21.375L29.25 12.375V30.375C29.25 30.6734 29.1315 30.9595 28.9205 31.1705C28.7095 31.3815 28.4234 31.5 28.125 31.5Z'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M21.375 4.5V12.375H29.25'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.0625 21.9375L18 25.875L21.9375 21.9375'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M18 16.875V25.875'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default FileDownloadIcon;
